//------------------------------------------------------------------------
// Google Tag Manager custom event tracking attribute
// https://developers.google.com/tag-manager/devguide#events
//
// Info on social tracking
// https://developers.google.com/tag-manager/reference#varnames
//
// Example:
// <a href="/example" data-gtm='{"key1":"value1","key2":"value2"}'>Lorem ipsum</a>
//------------------------------------------------------------------------
/* jshint scripturl:true */
/* globals dataLayer */

'use strict';
import $ from 'jquery';
import Backbone from 'backbone';

var AnalyticsViewController = Backbone.View.extend({
  el: 'body',

  events: {
    'click [data-gtm]': 'clickHandler',
  },

  // Helper function to follow links that have preventDefault() applied
  followLink: function($target) {
    var targetHref = $target.attr('href');
    // console.log('follow link', targetHref);

    // Ensure the href attribute has content
    if ( targetHref.length > 0 ) {
      // Navigate to link href
      document.location = targetHref;
    }
  },

  // Handle click event
  clickHandler: function(evt) {
    var self = this;
    var $target = $(evt.currentTarget);
    var trackingData = false;

    // Attempt to convert “data-gtm” string to JSON
    try {
      trackingData = $.parseJSON($target.attr('data-gtm'));
    } catch(e) {
      // If JSON is malformed, exit
      console.warn('Google Tag Manager: JSON data is not valid “' + $target.attr('data-gtm') + '”');
      return false;
    }

    var opensNewWindow = false;
    var wasPrevented = false;// if evt.preventDefault() was applied
    var isLink = $target.is('a[href]');
    var isJumpLink = isLink && $target.attr('href').indexOf('#') === 0;

    // We need to prevent default on regular links to ensure GTM receives the data before navigating away.
    if ( isLink ) {

      // Check if link should open in a new window
      opensNewWindow = $target.is('[target="_blank"]') || evt.which > 1 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey;

      // Don’t prevent default on jump links or links that open in a new window
      if ( !isJumpLink && !opensNewWindow ) {
        evt.preventDefault();
        wasPrevented = true;
      }
    }

    // Add callback to GTM data so any links we applied preventDefault() to will still work
    if ( wasPrevented ) {
      trackingData.eventCallback = function() {
        self.followLink($target)
      };
    }

    // console.log({'isLink':isLink, 'opensNewWindow':opensNewWindow, 'isJumpLink':isJumpLink, 'wasPrevented':wasPrevented, 'trackingData':trackingData});

    // Send data to GTM (use try/catch to be extra safe since we don't want to break links globally)
    try {
      // console.log('Sending data to GTM…');
      window.dataLayer.push(trackingData);
    } catch(e) {
      console.warn('Google Tag Manager: Unable to push data to dataLayer');

      // Since GTM callback won’t run, we need to follow any prevented links here
      if ( wasPrevented ) {
        this.followLink($target);
      }
    }
  }
});

var analytics = new AnalyticsViewController();